module.exports = __webpack_public_path__ + "img/menu.b1922920.svg";